module.exports = global["tv4"] = require("-!./tv4.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?tv4!./~/tv4/tv4.js
// module id = 467
// module chunks = 0